<ng-container *transloco="let t">
    <h1>{{ t('hot-offer-list.title') }}</h1>

    <td-hot-offer-table></td-hot-offer-table>
</ng-container>
